module.exports = __webpack_public_path__ + "img/mezzanine.6a46c879.jpg";